import { render } from "./AppProjects.vue?vue&type=template&id=d086bfd2"
const script = {}

import "./AppProjects.vue?vue&type=style&index=0&id=d086bfd2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__